module.exports = __webpack_public_path__ + "media/images/about-us/Bottom Right - Ocean-31b37487783ad02fd763ba7c39d60e31.jpeg";